import Image from "next/image";
import { Fragment } from "react";
import { useIntl } from "react-intl";
import { useMantineTheme } from "@mantine/core";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
} from "@/utils/strapi";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { defaultImageQuality } from "@/const/imageQuality";
import { StrapiImage } from "@/utils/strapi";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import HydratedMediaQuery from "@/utils/hydratedMediaQuery";
import { getBreakpoint } from "@/utils/mantine";
import styles from "./PointOfInterestList.module.scss";

export type PointOfInterestProps = {
  image: StrapiEntity<StrapiImage> | null;
  title: string | null;
  text: string;
};

export type PointOfInterestListProps = {
  pointOfInterests: PointOfInterestProps[];
};

export const PointOfInterestList = ({
  location,
  pointOfInterestList,
}: {
  location: string;
  pointOfInterestList: PointOfInterestListProps | null;
}) => {
  const intl = useIntl();
  const theme = useMantineTheme();
  const isTabletOrDesktop = HydratedMediaQuery(
    getBreakpoint(theme.breakpoints.md)
  );

  return (
    <div className={styles.pointOfInterestList}>
      {pointOfInterestList !== null &&
        pointOfInterestList.pointOfInterests.length > 0 &&
        pointOfInterestList.pointOfInterests.map((pointOfInterest) => (
          <Fragment key={pointOfInterest.text}>
            {pointOfInterest.title !== null && (
              <h2 className={styles.title}>{pointOfInterest.title}</h2>
            )}
            {pointOfInterest.image?.data && (
              <div className={styles.image}>
                <Image
                  width={816}
                  height={380}
                  layout="fixed"
                  objectFit={isTabletOrDesktop ? "contain" : "cover"}
                  src={addBasePathToStrapiMedia(
                    formatStrapiEntity(pointOfInterest.image)
                  )}
                  alt={intl.formatMessage(
                    { id: "pointOfInterestListAlternativeText" },
                    { location }
                  )}
                  quality={defaultImageQuality}
                />
              </div>
            )}
            <div
              className={styles.text}
              dangerouslySetInnerHTML={injectPurifiedHTML(
                removeEmptyRel(pointOfInterest.text)
              )}
            />
          </Fragment>
        ))}
    </div>
  );
};
